/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', () => {
  const languageSelects = document.querySelectorAll(
    '.acg-form__select__language'
  );

  if (!languageSelects) {
    return;
  }

  const documentLanguage = () => {
    languageSelects.forEach(languageSelect => {
      let languageFile = '';

      let title = '';

      if (languageSelect.options[languageSelect.selectedIndex]) {
        const downloadBtn = languageSelect.closest(
          '.acg-doc-summary-list__split'
        ).children[1];

        if (languageSelect.closest('.acg-doc-summary-list__split-layout')) {
          title = languageSelect.closest('.acg-doc-summary-list__split-layout')
            .children[0].children[0];
        }

        languageFile =
          languageSelect.options[languageSelect.selectedIndex].dataset.file;

        downloadBtn.setAttribute('href', languageFile);

        if (title) {
          title.setAttribute('href', languageFile);
        }
      }
    });
  };

  window.addEventListener('change', documentLanguage);
});
